import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ReservationPriority } from './reservation-priority.model';
import { ReservationPriorityPopupService } from './reservation-priority-popup.service';
import { ReservationPriorityService } from './reservation-priority.service';
import { School, SchoolService } from '../school';
import { ClassType, ClassTypeService } from '../class-type';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal } from '../../shared/index';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-reservation-priority-dialog',
    templateUrl: './reservation-priority-dialog.component.html'
})
export class ReservationPriorityDialogComponent extends AbstractDialogComponent  implements OnInit {

    reservationPriority: ReservationPriority;
    authorities: any[];
    isSaving: boolean;

    classtypes: ClassType[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private reservationPriorityService: ReservationPriorityService,
        schoolService: SchoolService,
        private classTypeService: ClassTypeService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['reservationPriority']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.classTypeService.query().subscribe(
            (res: HttpResponse<ClassType[]>) => { this.classtypes = res.body; },
            (res: HttpErrorResponse) => this.onError(res));
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.reservationPriority.id !== undefined) {
            this.reservationPriorityService.update(this.reservationPriority)
                .subscribe((res: ReservationPriority) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.reservationPriorityService.create(this.reservationPriority)
                .subscribe((res: ReservationPriority) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: ReservationPriority) {
        this.eventManager.broadcast({ name: 'reservationPriorityListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackClassTypeById(index: number, item: ClassType) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-reservation-priority-popup',
    template: ''
})
export class ReservationPriorityPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationPriorityPopupService: ReservationPriorityPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.reservationPriorityPopupService
                    .open(ReservationPriorityDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.reservationPriorityPopupService
                    .open(ReservationPriorityDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority-dialog.component.ts